import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import style from "./CustomTable.module.css";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { CircularProgress, Grid, Pagination, Switch } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";

const CustomTable = ({
  data,
  columns,
  pageNo,
  pageLimit,
  handleEdit,
  handleDelete,
  handleActive,
  handleDisplay,
  handlePageChange,
  pageNumber,
  pageCount,
  loading,
}) => {
  console.log("data===",data)
  const handlePageChangePagination = (event, value) => {
    // console.log(value)
    handlePageChange(value);
  };

  let page = pageNumber ? pageNumber : 1;
  let limit = pageLimit ? pageLimit : 10;
  let count = pageCount ? pageCount : 1;

  const getNestedProperty = (obj, path) => {
    const keys = path.split(".");
    let result = obj;
    for (const key of keys) {
      
      result = result[key];
      if (result === undefined) {
        return "";
      }
    }
    result=result instanceof File ? URL.createObjectURL(result) : result;
    if(path==="price" && result?.rate!=null && result?.currency!=null){
      const rate=result?.rate+" "+result?.currency
      result=rate
    }
    if(path==='explorerId'){
      result=result?.fullname
    }
    if(path==='createdAt'){
      const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleDateString();
      };
      const createdAt = result?.createdAt;
      const formattedDate = formatDate(createdAt);
      result=formattedDate
    }
    return result;
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
            {
              console.log("Column Field", columns)
            }
          <TableContainer component={Paper} className={style.main_div}>
            <Table stickyHeader aria-label="sticky table">
               <TableHead>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      key={index}
                      align={column.align}
                      sx={{
                        fontWeight: "bolder",
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead> 
              <TableBody>
                {data?.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {columns.map((column, columnIndex) => (
                      <TableCell key={columnIndex} align={column.align}>
                        {column.id === "action" ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                              }}
                            >
                              {row?.action?.edit && (
                                <div
                                  onClick={() => {
                                    // Handle edit action for this row
                                    handleEdit(row);
                                  }}
                                >
                                  <EditIcon
                                    style={{
                                      fontSize: "24px",
                                      borderRadius: "3px",
                                      cursor: "pointer",
                                      color: "green",
                                    }}
                                  />
                                </div>
                              )}
                              {row?.action?.delete && (
                                <div
                                  onClick={() => {
                                    // Handle delete action for this row
                                    handleDelete(row);
                                  }}
                                >
                                  <DeleteIcon
                                    style={{
                                      fontSize: "24px",
                                      borderRadius: "3px",
                                      cursor: "pointer",
                                      color: "red",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        ) : column.id === "S.No" ? (
                          ++rowIndex + (page - 1) * limit
                        ) : column.type === "IMAGE" ? (
                          <>
                            <a href={getNestedProperty(row, column.id)} target="_blank" rel="noopener noreferrer" className='flex justify-center '>
                            <img
                              src={getNestedProperty(row, column.id)}
                              alt="banner"
                              style={{ width: "50px", height: "50px",}}
                            />
                            </a>
                          </>
                        ) : column.label === "Active" ? (
                          <Switch
                            checked={row[column.id]}
                            onChange={(event) => {
                              const newActiveValue = event.target.checked;
                              row[column.id] = newActiveValue;
                              handleActive(row?._id, newActiveValue, "active", row);
                            }}
                          />
                        ) : column.label === "Published" ? (
                          <Switch
                            checked={row[column.id]}
                            disabled={true}
                            onChange={(event) => {
                              const newActiveValue = event.target.checked;
                              handleActive(
                                row?._id,
                                newActiveValue,
                                "published",
                                row
                              );
                            }}
                          />
                        ) : column.label === "Details" ? (
                          <div
                            onClick={() => {
                              handleDisplay(row);
                            }}
                          >
                            <VisibilityIcon
                              style={{
                                fontSize: "24px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "green",
                              }}
                            />
                          </div>
                        ) : column.label === "Vendor Email" ? (
                          row?.vendorId?.email
                        ) : column.id === "socialMediaLink" ? (
                          row?.socialMediaLink === true ? (
                            "YES"
                          ) : (
                            "NO"
                          )
                        ) : column.id === "ticketSystem" ? (
                          row?.ticketSystem === true ? (
                            "YES"
                          ) : (
                            "NO"
                          )
                        ) : column.id === "datetime" ? (
                          `${row?.startDate} - ${row?.startTime}`
                        ) : column.id === "enddatetime" ? (
                          `${row?.endDate} - ${row?.endTime}`
                        ) : column.id === "createdAt" ? (
                          moment.utc(row?.createdAt).add(5,"hours").add(30,"minutes").format("YYYY-MM-DD HH:mm")
                        ) : column.id === "startDate" ? (
                          moment
                            .utc(row?.startDate)
                            .add(5, "hours").add(30, "minutes")
                            .format("YYYY-MM-DD HH:mm")
                          // moment.utc(row?.startDate).format("YYYY-MM-DD HH:mm")
                        ) : column.id === "endDate" ? (
                          // moment.utc(row?.endDate).format("YYYY-MM-DD HH:mm")
                          moment
                            .utc(row?.endDate)
                            .add(5, "hours").add(30, "minutes")
                            .format("YYYY-MM-DD HH:mm")
                        ) : column.label === "Current Subscription" ? (
                          row?.activeSubscription ? (
                            row?.activeSubscription?.subscriptionTypeId?.name
                          ) : (
                            "InActive"
                          )
                        ) : column.label === "Subscription Expiry" ? (
                          row?.activeSubscription ? (
                            moment
                              .utc(row?.activeSubscription?.expiryDate)
                              .format("YYYY-MM-DD")
                          ) : (
                            "-"
                          )
                        ) : column.id === "vendorName" ? (
                          row?.vendorId?.fullName
                        ) : column.id === "addonName" ? (
                          row?.addon?.name
                        ) : column.label === "Country" ? (
                          row?.homeCountry?.split(",")[2]
                        ) : column.label === "City" ? (
                          row?.homeCountry?.split(",")[0]
                        ) : column.id === "gAddress" ? (
                          row?.gAddress?.split(",").pop()?.trim()
                        ) :  column.id === "exploreremail" ? (
                          row?.user?.email
                        ): 
                         column.id === "buddyemail" ? (
                          row?.reportedBy?.email
                        ) 
                        : 
                         column.id === "comment" ? (
                          row?.reason
                        ) :(
                          getNestedProperty(row, column.id) 
                        )} 
                       
                       
                        
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid justifyContent={"center"} container pt={3}>
            <Pagination
              align="center"
              count={count}
              page={page}
              onChange={handlePageChangePagination}
            />
          </Grid>
        </>
      )}
    </>
  );
};
export default CustomTable;
